import apiService from './apiService';

const featuredService = {
  // ========== PROVIDER ENDPOINTS ==========
  
  // Elérhető tier-ek lekérése kategóriánként
  async getCategoryTiers(categoryId) {
    try {
      const response = await apiService.get(`/featured/categories/${categoryId}/tiers`);
      return response;
    } catch (error) {
      console.error('Get category tiers error:', error);
      throw error;
    }
  },

  // Saját aktív előfizetés
  async getMyActiveSubscription() {
    try {
      const response = await apiService.get('/featured/my-subscription');
      return response;
    } catch (error) {
      console.error('Get my active subscription error:', error);
      if (error.status === 404) {
        return { success: true, data: null };
      }
      throw error;
    }
  },

  // Saját összes előfizetés
  async getMySubscriptions() {
    try {
      const response = await apiService.get('/featured/my-subscriptions');
      return response;
    } catch (error) {
      console.error('Get my subscriptions error:', error);
      throw error;
    }
  },

  // Slot elérhetőség ellenőrzése
  async checkAvailability(categoryId, tier) {
    try {
      const response = await apiService.get(`/featured/availability/${categoryId}/${tier}`);
      return response;
    } catch (error) {
      console.error('Check availability error:', error);
      throw error;
    }
  },

  // Előfizetés vásárlása
  async purchaseSubscription(categoryId, tier, billingPeriod, autoRenew = false, termsAccepted = false) {
    try {
      const response = await apiService.post('/featured/purchase', {
        categoryId,
        tier,
        billingPeriod,
        autoRenew,
        termsAccepted
      });
      return response;
    } catch (error) {
      console.error('Purchase subscription error:', error);
      throw error;
    }
  },

  // Megújítás kifizetése (Barion) — a jelenlegi időszak végén indul
  async renewSubscription(subscriptionId) {
    try {
      return await apiService.post(`/featured/${subscriptionId}/renew`);
    } catch (error) {
      console.error('Renew subscription error:', error);
      throw error;
    }
  },

  // Auto-renew toggle
  async toggleAutoRenew(subscriptionId) {
    try {
      const response = await apiService.patch(`/featured/${subscriptionId}/toggle-renewal`);
      return response;
    } catch (error) {
      console.error('Toggle auto-renew error:', error);
      throw error;
    }
  },

  // Előfizetés lemondása
  async cancelSubscription(subscriptionId) {
    try {
      const response = await apiService.delete(`/featured/${subscriptionId}/cancel`);
      return response;
    } catch (error) {
      console.error('Cancel subscription error:', error);
      throw error;
    }
  },

  // ========== ADMIN ENDPOINTS ==========
  
  async getCategoryTierLimits(categoryId) {
    try {
      const response = await apiService.get(`/featured/admin/categories/${categoryId}/limits`);
      return response;
    } catch (error) {
      console.error('Get category tier limits error:', error);
      throw error;
    }
  },

  async updateCategoryTierLimit(categoryId, tier, limitData) {
    try {
      const response = await apiService.put(`/featured/admin/categories/${categoryId}/limits`, {
        tier,
        ...limitData
      });
      return response;
    } catch (error) {
      console.error('Update category tier limit error:', error);
      throw error;
    }
  },

  async getAllSubscriptions(filters = {}) {
    try {
      const response = await apiService.get('/featured/admin/subscriptions', filters);
      return response;
    } catch (error) {
      console.error('Get all subscriptions error:', error);
      throw error;
    }
  },

  async adminActivateSubscription(subscriptionId) {
    try {
      const response = await apiService.patch(`/featured/admin/${subscriptionId}/activate`);
      return response;
    } catch (error) {
      console.error('Admin activate subscription error:', error);
      throw error;
    }
  },

  async adminExpireSubscription(subscriptionId) {
    try {
      const response = await apiService.patch(`/featured/admin/${subscriptionId}/expire`);
      return response;
    } catch (error) {
      console.error('Admin expire subscription error:', error);
      throw error;
    }
  },

  // Ingyenes korai ajánlat (kártya nélkül)
  getEarlyOffer: () => apiService.get('/featured/early-offer'),
  claimEarlyOffer: (categoryId) => apiService.post('/featured/early-offer/claim', { categoryId }),
  unsubscribeEarlyOffer: (userId, token) => apiService.post('/featured/early-offer/unsubscribe', { userId, token }),
  adminEarlyOfferRecipients: () => apiService.get('/featured/admin/early-offer/recipients'),
  adminPreviewEarlyOffer: (templateId, providerId) => apiService.post('/featured/admin/early-offer/preview', { templateId, providerId }),
  adminSendEarlyOffer: (providerIds, templateId, dryRun) => apiService.post('/featured/admin/early-offer/send', { providerIds, templateId, dryRun }),

  async adminAssignTier(providerId, categoryId, tier, endsAt) {
    try {
      const response = await apiService.post('/featured/admin/assign', {
        providerId,
        categoryId,
        tier,
        endsAt
      });
      return response;
    } catch (error) {
      console.error('Admin assign tier error:', error);
      throw error;
    }
  }
};

export default featuredService;